module.exports = __webpack_public_path__ + "img/dcb9759.png";